import React from "react";
import "../../../styles/utils/modal/NotSelectModal.scss";

export default function NotSelectModal({ message, onClose, isCharge, onCharge }) {
  return (
    <div className="not-select-modal">
      <div className="modal-content">
        <p className="message">{message}</p>
        <button
          className="close-btn"
          onClick={isCharge ? onCharge : onClose}
        >
          {isCharge ? "충전하기" : "확인"}
        </button>
      </div>
    </div>
  );
}
